export class Group {
  group_id: number;
  group_nickname: string;
  is_default: boolean;
  chatroom_list: Array<Chatroom>;
  shown: boolean;
  disabled: boolean;

  constructor(group: any = {}) {
    this.group_id = group.group_id || null;
    this.group_nickname = group.group_nickname || null;
    this.is_default = group.is_default || null;
    this.chatroom_list = group.chatroom_list
      ? group.chatroom_list.map(item => new Chatroom(item))
      : [];
  }

  get group_status() {
    return this.chatroom_list.some(item => !!item.status);
  }
}

export class Chatroom {
  chatroom_id: number;
  chatroom_nickname: string;
  chatroom_member_count: number;
  chatroomname: string;
  avatar_url: string;
  status: number; //0 正常
  expire_time: number;
  member_count: number;
  nickname: string;
  checked: boolean;
  disabled: boolean;
  nickname_default: string;
  robot_roomowner; boolean;
  is_work:number;

  constructor(chatroom: any = {}) {
    this.chatroom_id = chatroom.chatroom_id || null;
    this.chatroom_nickname =
      chatroom.nickname ||
      chatroom.chatroom_nickname ||
      chatroom.nickname_default ||
      '一个微信群';
    this.chatroom_member_count = chatroom.chatroom_member_count || null;
    this.avatar_url = chatroom.avatar_url || null;
    this.chatroomname = chatroom.chatroomname;
    this.status = chatroom.chatroom_status || null;
    this.expire_time = chatroom.expire_time || null;
    this.nickname = chatroom.nickname || null;
    this.member_count = chatroom.member_count || null;
    this.robot_roomowner = chatroom.robot_roomowner || null
    this.is_work = chatroom.is_work || 0;
  }
}



// WEBPACK FOOTER //
// ./src/class/chatroom.ts